import { MenuItemAggregate } from '../../../../../aggregats/menu/menu-item.aggregate';
import {
  automatisationsSousMenuItem,
  connecteursSousMenuItem,
  entitesSousMenuItem,
  parametresSousMenuItem,
  personnelsSousMenuItem,
  profilsDroitsSousMenuItem,
} from './sous-menu-items.constantes';

export const parametragesMenuItem: MenuItemAggregate = new MenuItemAggregate('icon-layers', 'Paramétrages', [
  profilsDroitsSousMenuItem,
  automatisationsSousMenuItem,
  parametresSousMenuItem,
  entitesSousMenuItem,
  personnelsSousMenuItem,
  connecteursSousMenuItem,
]);
